export enum Role {
  superuser = 'SUPERUSER',
  credibilaAdmin = 'CREDIBILA_ADMIN',
  investor = 'INVESTOR',
  credibilaDev = 'CREDIBILA_DEV',
}

export type UtmAttributionPayload = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  captured_at?: string
  landing_path?: string
}

export interface NewUser {
  name: string
  email: string
  password: string
  role: Role.investor
  referralCode?: string
  utmAttribution?: UtmAttributionPayload
  signupContext?: { source: 'promote-otp'; page?: string }
}

export interface User {
  email: string
  password: string
}

export interface Admin extends User {
  adminEmail: string
}

export enum Verification {
  verifyEmail = 'verify-email',
  resetPassword = 'reset-password',
}
